import { render, staticRenderFns } from "./PopupFooter.vue?vue&type=template&id=39f60fa6"
import script from "./PopupFooter.vue?vue&type=script&lang=ts"
export * from "./PopupFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports